<div class="content-div">

  <div class="info-bar">
    <app-breadcrumbs [breadcrumbs]="BreadcrumbsLink"></app-breadcrumbs>
    <app-basic-button type="tertiary" size="medium" (click)="exportUserList()">
      <i class="far fa-upload"></i>
      <span> {{ 'users:export_user_list' | i18next }}</span>
    </app-basic-button>
    <app-basic-button type="tertiary" size="medium" (click)="openImportDialog()">
      <i class="far fa-download"></i>
      <span> {{ 'users:user_importUserSimpleUpdate' | i18next }}</span>
    </app-basic-button>

    <app-basic-button type="secondary" isIcon="true" size="medium" (click)="openHelp()">
      <i class="fal far fa-info-circle fs-16"></i>
    </app-basic-button>
  </div>

  <div class="top-bar">
    <span class="page-header">
      {{ 'users:users' | i18next }}
    </span>
    <div class="right">
      <app-basic-button type="secondary" size="medium" class="add-button" [disabled]="!canAddUsers" routerLink="/users/new-group-number">
        <i class="far fa-plus"></i>
        <span>{{ 'users:users_createNewGroupNumber' | i18next }}</span>
      </app-basic-button>
      <app-basic-button type="primary" size="medium" class="add-button" [disabled]="!canAddUsers" routerLink="/users/new-user/">
        <i class="far fa-plus"></i>
        <span>{{ 'users:newuser_createNew' | i18next }}</span>
      </app-basic-button>
      <app-filter-input [(model)]="filterText" [placeholder]="'users:usergroups_filterPlaceholder' | i18next"
        [width]="'350px'" (modelChange)="onFilterInputChange($event)" (enter)="onFilterChange()"></app-filter-input>
      <app-basic-button type="primary" size="medium" class="add-button" [isIcon]="true" [disabled]="!filterText"
        (click)="onFilterChange()">
        <i class="far fa-search fs-16"></i>
      </app-basic-button>
    </div>
  </div>
  <div class="top-bar filter-bar">
    <div class="skills">
      <app-basic-dropdown [label]="'users:skillsHeader' | i18next" [showIcon]="false" [width]="'200px'"
        [items]="skillOptions" bindLabel="name" bindValue="id" [(model)]="selectedSkillId" [clearable]="true"
        (modelChange)="onSkillChange()"></app-basic-dropdown>
      <app-basic-dropdown [label]="'users:shared_level' | i18next" [showIcon]="false" [width]="'200px'" [items]="skillLevels"
        bindLabel="label" bindValue="value" [(model)]="selectedLevels" [searchable]="false"
        [disabled]="ddlLevelDisabled" (modelChange)="onFilterChange()" [multiple]="true"></app-basic-dropdown>
    </div>
    <app-basic-dropdown [label]="'users:globalprofiles_lang_profile' | i18next" [showIcon]="false" [width]="'200px'"
      [items]="profileOptions" bindLabel="profileDescript" bindValue="profileId" [(model)]="selectedProfileId" (modelChange)="onFilterChange()"></app-basic-dropdown>
    <app-basic-dropdown [label]="'users:newuser_label_userGroup' | i18next" [showIcon]="false" [width]="'200px'"
      [items]="userGroupOptions" bindLabel="name" bindValue="id" [(model)]="selectedUserGroupId" (modelChange)="onFilterChange()"></app-basic-dropdown>
    <div class="checkbox-container">
      <div class="checkbox-header">{{ 'users:ShowHide_columns' | i18next }}</div>
      <div class="checkbox-row">
        <app-basic-checkbox [(model)]="showNumericId"
          [label]="'users:shared_userIdsTableHeader' | i18next"></app-basic-checkbox>
        <app-basic-checkbox [(model)]="showKeywords"
          [label]="'users:showKeywordsLabel' | i18next"></app-basic-checkbox>
        <app-basic-checkbox [(model)]="showExternalUserId"
          [label]="'users:newuser_label_externalUserId' | i18next"></app-basic-checkbox>
        <app-basic-checkbox [(model)]="showLastSignIn"
          [label]="'users:users_last_SignIn' | i18next"></app-basic-checkbox>
      </div>
    </div>
  </div>


  <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
  <table mat-table [dataSource]="filteredUsers" matSort (matSortChange)="onSortChange($event)"
    class="mat-elevation-z2 full-width-table" *ngIf="filteredUsers?.length; else noUsers">
    <!-- Name -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'users:Name' | i18next }}
      </th>
      <td mat-cell *matCellDef="let r" [class.user-offline]="r.faded">
        <a *ngIf="canEditUser(r)" [routerLink]="['/users/edit-user', r.id]" class="user-name-link"
          [matTooltip]="generateFullName(r)" matTooltipClass="tooltip-font-14"
          [matTooltipDisabled]="generateFullName(r).length <= 50">
          {{ generateFullName(r).length > 50 ? (generateFullName(r) | slice:0:50) + '...' : generateFullName(r) }}
        </a>
        <span *ngIf="!canEditUser(r)"
          [matTooltip]="generateFullName(r)" matTooltipClass="tooltip-font-14"
          [matTooltipDisabled]="generateFullName(r).length <= 50">
          {{ generateFullName(r).length > 50 ? (generateFullName(r) | slice:0:50) + '...' : generateFullName(r) }}
        </span>
      </td>
    </ng-container>
    <!-- Email -->
    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'users:users_tooltip_emailHeader' | i18next }}
      </th>
      <td mat-cell *matCellDef="let r" [class.user-offline]="r.faded" [matTooltip]="r.email"
        matTooltipClass="tooltip-font-14" class="center-align">
        <i class="far fa-envelope fs-16" *ngIf="r.email"></i>
        {{ r.email ? '' : '-' }}
      </td>
    </ng-container>
    <!-- Mobile -->
    <ng-container matColumnDef="mobile">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'users:users_tooltip_mobileHeader' | i18next }}
      </th>
      <td mat-cell *matCellDef="let r" [class.user-offline]="r.faded" [matTooltip]="r.mobilePhone"
        matTooltipClass="tooltip-font-14" class="center-align">
        <i class="far fa-mobile fs-16" *ngIf="r.mobilePhone"></i>
        {{ r.mobilePhone ? '' : '-' }}
      </td>
    </ng-container>
    <!-- Filter -->
    <ng-container matColumnDef="filter">
      <th mat-header-cell *matHeaderCellDef >
        {{ 'users:filterLabel' | i18next }}
      </th>
      <td mat-cell *matCellDef="let r" [class.user-offline]="r.faded" class="center-align" >
        <app-basic-button type="tertiary" size="medium" [isIcon]="true" [matMenuTriggerFor]="filterMenu"
          (click)="filterMenuOpen(r)" [matTooltip]="getFilterTooltip(r.filter)"
          matTooltipClass="tooltip-font-14"
          *ngIf="r.filter && getFilterItems(r.filter).length">
          <i class="far fa-filter fs-16"></i>
        </app-basic-button>

        <span *ngIf="r.filter && !getFilterItems(r.filter).length" [matTooltip]="r.filter"
          matTooltipClass="tooltip-font-14">
          <i class="far fa-filter fs-16"></i>
        </span>
        <span *ngIf="!r.filter">-</span>
      </td>
    </ng-container>
    <!-- BOSE -->
    <ng-container matColumnDef="boSE">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        BOSE
      </th>
      <td mat-cell *matCellDef="let r" [class.user-offline]="r.faded"
        [matTooltip]="r.userBose === false ? '' : ('users:users_tooltip_bot' | i18next)"
        [matTooltipDisabled]="r.userBose === false" matTooltipClass="tooltip-font-14" class="center-align">
        <i class="far fa-robot fs-16" *ngIf="r.userBose === true"></i>
        {{ r.userBose === true ? '' : '-' }}
      </td>
    </ng-container>
    <!-- Type -->
    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'users:newuser_label_userTypes' | i18next }}
      </th>
      <td mat-cell *matCellDef="let r" [class.user-offline]="r.faded" class="center-align"
        [matTooltip]="r.userTypeName || r.userType" matTooltipClass="tooltip-font-14"
        [matTooltipDisabled]="!r.userType || r.userType==0">
        @switch (r.userType) {
          @case (1) { <span class="fs-12">API</span>}
          @case (2) {<i class="far fa-th-large fs-16"></i>}
          @case (3) {<i class="far fa-comment fs-16"></i>}
          @default {-}
        }
      </td>
    </ng-container>
    <!-- User group -->
    <ng-container matColumnDef="user group">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'users:users_userGroup' | i18next }}
      </th>
      <td mat-cell *matCellDef="let r" [class.user-offline]="r.faded">
        {{ r.userGroup || '-' }}
       <i class="far fa-hourglass-half" *ngIf="r.pendingUsergroupName" [matTooltip]="r.pendingUsergroupName||''" matTooltipClass="tooltip-font-14"></i>
      </td>
    </ng-container>
    <!-- Username -->
    <ng-container matColumnDef="username">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'users:UserName' | i18next }}
      </th>
      <td mat-cell *matCellDef="let r" [class.user-offline]="r.faded">
        {{ r.userName || '-' }}
      </td>
    </ng-container>
    <!-- Sync -->
    <ng-container matColumnDef="sync">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Sync
      </th>
      <td mat-cell *matCellDef="let r" [class.user-offline]="r.faded" [matTooltip]="('users:users_tooltip_userSynchId' | i18next) +' '+ r.oneIdentityId"
        matTooltipClass="tooltip-font-14" [matTooltipDisabled]="!r.oneIdentityId" class="center-align">
        <i class="far fa-sync fs-16" *ngIf="r.oneIdentityId"></i>
        {{ r.oneIdentityId ? '' : '-' }}
      </td>
    </ng-container>
    <!-- Puzzel ID -->
    <ng-container matColumnDef="puzzel ID">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'users:newuser_label_oneIdentityUsername' | i18next }}
      </th>
      <td mat-cell *matCellDef="let r" [class.user-offline]="r.faded">
        {{ r.oneIdentityUsername || '-' }}
      <span *ngIf="r.oneIdentityUsername && r.email && r.oneIdentityUsername != r.email" [matTooltip]="'users:users_tooltip_unmachingPuzzelId' | i18next"  matTooltipClass="tooltip-font-14">
        <i class="far fa-exclamation-circle fs-12 red"></i>
      </span>
      </td>
    </ng-container>
    <!-- Delete -->
    <ng-container matColumnDef="delete">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'users:usersfilter_delete' | i18next }}
      </th>
      <td mat-cell *matCellDef="let r" [class.user-offline]="r.faded" class="center-align">
       <app-basic-button type="decline" size="small" [isIcon]="true" (click)="deleteUser(r)" [disabled]="deleteDisabled(r)" >
         <i class="far fa-times fs-14"></i>
      </app-basic-button>
      </td>
    </ng-container>
    <!-- Numeric ID -->
    <ng-container matColumnDef="Numeric ID">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'users:shared_userIdsTableHeader' | i18next }}
      </th>
      <td mat-cell *matCellDef="let r" [class.user-offline]="r.faded">
        {{ (!r.num || r.num == 'users_noUserNumber')? '-': r.num }}
      </td>
    </ng-container>
    <!-- Keywords -->
    <ng-container matColumnDef="Keywords">
      <th mat-header-cell *matHeaderCellDef >
        {{ 'users:newuser_label_keywords' | i18next }}
      </th>
      <td mat-cell *matCellDef="let r" [class.user-offline]="r.faded">
        {{ formatKeywords(r.keywords) }}
      </td>
    </ng-container>
    <!-- External User ID -->
    <ng-container matColumnDef="External User ID">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'users:newuser_label_externalUserId' | i18next }}
      </th>
      <td mat-cell *matCellDef="let r" [class.user-offline]="r.faded">
        {{ r.externalId || '-' }}
      </td>
    </ng-container>
    <!-- Last sign-in -->
    <ng-container matColumnDef="Last sign-in">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'users:users_last_SignIn' | i18next }}
      </th>
      <td mat-cell *matCellDef="let r" [class.user-offline]="r.faded">
        {{ r.lastLoginStr || '-' }}
      </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" [attr.data-user-id]="row.userId"
      [class.user-offline]="row.faded">
    </tr>

    <!-- No data row for details table -->
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length">
        <ng-container *ngTemplateOutlet="noData"></ng-container>
      </td>
    </tr>
  </table>
  <ng-template #noUsers>
    <div class="no-items">
      {{ 'realtime:noResults' | i18next }}
    </div>
  </ng-template>

  <app-paginator [length]="datasetLength" [pageSize]="pageSize" [pageIndex]="pageNum - 1" (pageChange)="onPageChange($event)"
    (pageSizeChange)="onPageSizeChange($event)"></app-paginator>

<div *ngIf="indexData?.showUnblockable" class="unblockable-section">
  <h3 class="sub-header">Group numbers</h3>
  <table mat-table matSort #unblockableSort="matSort" [dataSource]="unblockableUsersDataSource" class="mat-elevation-z2 full-width-table unblockable-table">
    <!-- Name -->
    <ng-container matColumnDef="userName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'users:Name' | i18next }}
      </th>
      <td mat-cell *matCellDef="let r">
        <a *ngIf="canEditUsers" [routerLink]="['/users/edit-group-number', r.id]" class="user-name-link">
          {{ r.userName || '-' }}
        </a>
        <span *ngIf="!canEditUsers">{{ r.userName || '-' }}</span>
      </td>
    </ng-container>
    <!-- Numeric ID -->
    <ng-container matColumnDef="num">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'users:shared_userIdsTableHeader' | i18next }}
      </th>
      <td mat-cell *matCellDef="let r">
        {{ (!r.num || r.num == 'users_noUserNumber')? '-': r.num }}
      </td>
    </ng-container>
    <!-- Delete -->
    <ng-container matColumnDef="delete">
      <th mat-header-cell *matHeaderCellDef class="delete-column-header">
        {{ 'users:usersfilter_delete' | i18next }}
      </th>
      <td mat-cell *matCellDef="let r" [class.user-offline]="r.faded" class="center-align">
       <app-basic-button type="decline" size="small" [isIcon]="true" (click)="deleteGroupNumber(r)" [disabled]="deleteDisabled(r)">
         <i class="far fa-times fs-14"></i>
      </app-basic-button>
      </td>
    </ng-container>
    <!-- No data row for details table -->
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="unblockableColumns.length">
        <ng-container *ngTemplateOutlet="noData"></ng-container>
      </td>
    </tr>
    <tr mat-header-row *matHeaderRowDef="unblockableColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: unblockableColumns" [attr.data-user-id]="row.userId" [class.user-offline]="row.faded"></tr>
    </table>

</div>



  <mat-menu #filterMenu="matMenu" class="filter-menu popup-menu">
    <button mat-menu-item *ngFor="let item of filterMenuItems" (click)="navigateToFilter(item.id)">
      <span>{{ item.description }}</span>
      &nbsp;
      <i class="far fa-external-link fs-14 filter-menu-link-icon"></i>
    </button>
  </mat-menu>



</div>
